// import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      players: [],
      // pictures: [],
    }
  },

  forSimple(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    }
  },

  forClub(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      players: data.players ? data.players : [],
      teamManagers: data.teamManagers ? data.teamManagers : [] ,
      coaches: data.coaches ? data.coaches :  []
    }
  },

  forGame(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club,
      score: 0
    }
  },

  forPlayer(data){
    return  {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    }
  },

  forCreate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures)
    };
  },

  forUpdate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures)
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/team/team-model.js